import Shikaku from './Shikaku';

export default function App() {
  return <Shikaku />;
}
